module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/155.87d271ad.png";